import { GlModal, GlButton, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, s__ } from '~/locale';
import { visitUrl } from '~/lib/utils/url_utility';
import { REF_TYPE_PARAM_NAME, TAG_REF_TYPE, BRANCH_REF_TYPE } from '../constants';
export default {
    name: 'AmbiguousRefModal',
    i18n: {
        title: s__('AmbiguousRef|Which reference do you want to view?'),
        description: sprintf(s__('AmbiguousRef|There is a branch and a tag with the same name of %{ref}.')),
        secondaryDescription: s__('AmbiguousRef|Which reference would you like to view?'),
        viewTagButton: s__('AmbiguousRef|View tag'),
        viewBranchButton: s__('AmbiguousRef|View branch')
    },
    tagRefType: TAG_REF_TYPE,
    branchRefType: BRANCH_REF_TYPE,
    components: {
        GlModal,
        GlButton,
        GlSprintf
    },
    props: {
        refName: {
            type: String,
            required: true
        }
    },
    mounted () {
        this.$refs.ambiguousRefModal.show();
    },
    methods: {
        navigate (refType) {
            const url = new URL(window.location.href);
            url.searchParams.set(REF_TYPE_PARAM_NAME, refType);
            visitUrl(url.toString());
        }
    }
};
